// extracted by mini-css-extract-plugin
export var actions = "_dl-d";
export var benefitCard = "_dl-a";
export var benefitIcon = "_dl-b";
export var benefitLabel = "_dl-c";
export var benefits = "_dl-9";
export var bodyText = "_dl-8";
export var closeButton = "_dl-2";
export var content = "_dl-3";
export var eyebrow = "_dl-4";
export var heading = "_dl-5";
export var image = "_dl-f";
export var imagePanel = "_dl-e";
export var modal = "_dl-0";
export var shell = "_dl-1";
export var title = "_dl-6";
export var titleOffer = "_dl-7";